module.exports = __webpack_public_path__ + "static/media/3.7fbe6af9.svg";